import { TextField, InputAdornment } from '../../Material/index'
import search from 'assets/icons/search.svg'
import cn from 'classnames'
import React from 'react'
import { NumericFormat } from 'react-number-format'

export type InputProps = {
  type?: string
  name: string
  label?: string
  placeholder?: string
  error?: string
  onClick?: () => void
  onBlur?: () => void
  className?: string
  onChange?: (value: number | string) => void
  value?: string | number
  disabled?: boolean
  iconName?: string
  variant?: 'standard' | 'filled' | 'outlined'
  maxLength?: number
}

type NumericFormatProps = React.ComponentProps<typeof NumericFormat>

type NumericFormatCustomProps = NumericFormatProps & {
  onChange: (e: { target: { value: number } }) => void
  maxLength?: number
}

const NumericFormatCustom = React.forwardRef((props: NumericFormatCustomProps, ref) => {
  const { onChange, maxLength, ...otherProps } = props

  return (
    <NumericFormat
      {...otherProps}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.floatValue || 0
          }
        })
      }}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      fixedDecimalScale
      prefix="R$ "
      isAllowed={(values) => {
        const { formattedValue } = values
        return formattedValue.length <= (maxLength || Infinity)
      }}
    />
  )
})

NumericFormatCustom.displayName = 'NumericFormatCustom'

export const MaskedInput = React.memo(
  ({
    name,
    label,
    placeholder,
    error,
    className,
    value,
    onClick,
    onBlur,
    onChange,
    disabled,
    iconName,
    variant = 'outlined'
  }: InputProps) => {
    return (
      <div className="relative group">
        <TextField
          fullWidth
          variant={variant}
          name={name}
          label={label}
          placeholder={placeholder}
          disabled={disabled}
          error={!!error}
          onClick={onClick}
          onBlur={onBlur}
          className={cn('md:max-w-[450px]', className)}
          InputProps={{
            style: {
              fontFamily: 'BB-Font-Regular',
              fontWeight: 'bold',
              backgroundColor: '#fff'
            },
            inputComponent: NumericFormatCustom as any,
            inputProps: {
              thousandSeparator: '.',
              decimalSeparator: ',',
              decimalScale: 2,
              fixedDecimalScale: true,
              prefix: 'R$ ',
              value,
              onChange: (event: React.FormEvent<HTMLInputElement>) => {
                const target = event.target as HTMLInputElement
                onChange && onChange(target.value)
              }
            },
            startAdornment: iconName && (
              <InputAdornment position="start">
                <Icon name={iconName} />
              </InputAdornment>
            )
          }}
          InputLabelProps={{
            style: {
              fontFamily: 'BB-Font-Regular'
            },
            shrink: true
          }}
        />
        {error && error !== 'required_field' && (
          <div className="mt-1 text-xs text-red-500">{error}</div>
        )}
      </div>
    )
  }
)

type IconProps = {
  name: string
}

const Icon: React.FC<IconProps> = ({ name }) => {
  if (name === 'search') {
    return <img src={search} alt="ícone de lupa" />
  }
  return <></>
}

MaskedInput.displayName = 'MaskedInput'
